<script>
  import { onMount } from 'svelte';
  export let imgSrc;
  export let mainDesc1 = '메인설명1';
  export let mainDesc2 = '메인설명2';

  let innerHeight, innerWidth;
  let wrapper;
  let target1, target2, target3;

  function usageAnim() {
    const targets = [target1, target2, target3];
    const boxTop = wrapper.getBoundingClientRect().top;

    if (boxTop < innerHeight * 0.5 && boxTop > innerHeight * -0.1) {
      targets.forEach((target) => target.classList.add('active'));
    } else {
      targets.forEach((target) => target.classList.remove('active'));
    }
  }
  onMount(() => {
    window.addEventListener('scroll', usageAnim);
  });
</script>

<svelte:window bind:innerHeight bind:innerWidth />
<article class="usage-container" bind:this={wrapper}>
  <div class="img-wrapper usage-anim" bind:this={target1}>
    <img
      class="usage-img usage-anim"
      bind:this={target2}
      src={imgSrc}
      alt="{mainDesc1} 사진"
    />
  </div>

  <div class="desc-wrapper usage-anim" bind:this={target3}>
    <h2 class="main-desc">{mainDesc1}</h2>
    <h2 class="main-desc">{mainDesc2}</h2>
  </div>
</article>
<div class="css-keeper usage-anim active img-wrapper usage-img desc-wrapper" />

<style>
  .usage-container {
    position: relative;
    width: 95%;
    height: 75vh;
    margin: auto;
    overflow: hidden;

    /* border: 1px solid #f0f0f0; */
    /* border-radius: 10px; */
    /* box-shadow: 1px 1px 1px grey; */
  }

  .img-wrapper {
    position: absolute;
    top: 5%;
    left: 8%;
    display: block;
    width: 90%;
    height: 90%;
    overflow: hidden;
    /* margin: auto; */
    /* margin-bottom: 20px; */
    box-shadow: 3px 3px 6px #333;
    transition: 0.3s;
    border-radius: 10px;
  }
  .desc-wrapper {
    position: absolute;
    left: 3%;
    /* width: 83%; */
    bottom: 10%;
    /* height: 16vh; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-shadow: 3px 3px 6px #333;
    /* border-radius: 10px; */
    /* background-color: #f3f3f3; */
    background-color: #f4f4f4;
    opacity: 0.93;
    /* background-color: rgba(3, 3, 3, 0.9); */
    /* color: #fdb501; */
    transition: 0.3s;
    padding: 4%;
  }

  .usage-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: 0.3s;
    opacity: 0.8;
  }

  @media screen and (min-width: 768px) {
    .usage-container:hover .img-wrapper {
      transform: scale(1.01);
    }
    .usage-container:hover .usage-img {
      transform: scale(1.03);
      opacity: 0.9;
    }
    .usage-container:hover .desc-wrapper {
      opacity: 0.98;
    }
  }
  h2 {
    margin: 0;
  }
  .main-desc::before {
    content: '- ';
  }
  .main-desc {
    /* margin: 0; */
    /* margin-left: 20px; */
    font-weight: 400;
    font-size: 24px;
    margin-bottom: 5px;
  }

  @media screen and (max-width: 1300px) {
    .usage-container {
      height: 60vh;
    }
  }
  @media screen and (max-width: 768px) {
    .usage-container {
      width: 100%;
      height: 64vh;
    }
    .img-wrapper {
      width: 97%;
      height: 97%;
      top: 3%;
      left: 3%;
    }
    .desc-wrapper {
      left: 0;
      /* width: 75%; */
      /* border-radius: 5px; */
      /* height: 20vh; */
    }
    .main-desc {
      font-size: 5vw;
    }

    .active.img-wrapper {
      transform: scale(1.01);
    }
    .active.usage-img {
      transform: scale(1.03);
      opacity: 0.9;
    }
    .active.desc-wrapper {
      opacity: 0.98;
    }
  }
  .css-keeper {
    display: none;
  }
</style>
